import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getGroupEnrollmentReport = payload =>
  call(websocketFetch, 'get_group_enrollment_report', {
    version: 1,
    group_id: payload.groupId,
  });
